export const MuiTooltip = {
	defaultProps: {
		placement: "top",
		disableInteractive: true,
	},
	styleOverrides: { tooltip: { backdropFilter: "blur(6px)" } },
};
